import { generateManifest } from "./manifest"


const urlParams = new URLSearchParams(window.location.search);
path = urlParams.get('path');
if (!path) {
  var path = window.location.pathname.replace(/^\/([^\/]+).*/i,'$1');
}

const lang = {
  davai: {
    name: "Давай Иврит",
    locale: "ru",
    destLocale: "he",
    courseNum: "4",
    logo: "logo-loading-davai.svg",
    font: "Arimo",
    direction: {
      src: "ltr",
      dest: "rtl",
    },
    path: "davai",
    indexes: {
      word: "he2ru_words",
      grammar: "he2ru_grammar",
      sentences: "he2ru_sentences",
      games: "he2ru_games",
    },
  },
  moriel: {
    name: "מוריאל אנגלית",
    locale: "he",
    destLocale: "en",
    courseNum: "3",
    logo: "logo-loading.svg",
    font: "Fredoka",
    direction: {
      src: "rtl",
      dest: "ltr",
    },
    path: "moriel",
    indexes: {
      word: "eng2heb_words",
      grammar: "eng2heb_grammar",
      sentences: "eng2heb_sentences",
      games: "word_games",
    },
  },
  sababa: {
    name: "Sababa Hebrew",
    locale: "en",
    destLocale: "he",
    courseNum: "5",
    logo: "logo-loading-sababa.svg",
    font: "Arimo",
    direction: {
      src: "ltr",
      dest: "rtl",
    },
    path: "sababa",
    indexes: {
      word: "he2en_words",
      grammar: "he2en_grammar",
      sentences: "he2en_sentences",
      games: "he2en_games",
    },
  }
};

let pickedLang
if (lang[path]) {
  pickedLang = lang[path]
}
else if (lang[localStorage.getItem("localeRoute")]) {
  pickedLang = lang[localStorage.getItem("localeRoute")]
}
else {
  pickedLang = lang.moriel;
}

localStorage.setItem("appName", pickedLang.name)
localStorage.setItem("locale", pickedLang.locale);
localStorage.setItem("destLocale", pickedLang.destLocale);
localStorage.setItem("srcDirection", pickedLang.direction.src);
localStorage.setItem("destDirection", pickedLang.direction.dest);
localStorage.setItem("courseNum", pickedLang.courseNum);
localStorage.setItem("wordsIndex", pickedLang.indexes.word);
localStorage.setItem("gamesIndex", pickedLang.indexes.games);
localStorage.setItem("grammarIndex", pickedLang.indexes.grammar);
localStorage.setItem("sentencesIndex", pickedLang.indexes.sentences);
localStorage.setItem("localeRoute", pickedLang.path);
localStorage.setItem("logoSvg", pickedLang.logo);

document.title = pickedLang.name;
const root = document.querySelector(':root');
root.style.direction = pickedLang.direction.src;
root.style.setProperty('--font-family', pickedLang.font);
root.style.setProperty('--src-direction', pickedLang.direction.src);
root.style.setProperty('--dest-direction', pickedLang.direction.dest);
root.style.setProperty('--src-position', pickedLang.direction.src == "ltr" ? "left" : "right");
root.style.setProperty('--dest-position', pickedLang.direction.dest == "ltr" ? "left" : "right");
generateManifest(pickedLang)


// WEBPACK FOOTER //
// ./src/locales/main.js